var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert alert-warning",class:{ 'd-inline-block': _vm.inline },attrs:{"role":"alert"}},[_vm._m(0),_c('div',{staticClass:"alert-content"},[_c('span',[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert-icon"},[_c('i',{staticClass:"fas mr-2 fa-bell-exclamation"})])
}]

export { render, staticRenderFns }